export default __webpack_public_path__ + "static/media/_DSC0169.8c003398.JPG";